// this is the event emitted by the payment iframe on complete, required for native payment webview
var PaymentState;
(function (PaymentState) {
    PaymentState["PAYMENT_COMPLETE"] = "PAYMENT_COMPLETE";
})(PaymentState || (PaymentState = {}));
export default PaymentState;
